import { Text } from '@tishman/components';
import React from 'react';
type TPrivateEventsImageCaption = {
  text?: string;
  right?: string;
};
export const PrivateEventsImageCaption = ({
  text,
  right = '8px',
}: TPrivateEventsImageCaption) => {
  if (!text) return null;
  return (
    <Text
      sx={{
        position: 'absolute',
        fontSize: [1, 2],
        fontWeight: 700,
        bottom: '4px',
        right,
        color: 'mediaCaption',
      }}
    >
      {text}
    </Text>
  );
};
